import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { DELAY_ADDRESS } from '../../constants'
import { useChainCall, useEthers } from '../../hooks'

const coder = new Interface(['function gasPrice() returns (uint256)'])

export function useDelayGasPrice() {
  const { chainId } = useEthers()
  const result = useChainCall(
    chainId !== undefined && {
      address: DELAY_ADDRESS[chainId],
      data: coder.encodeFunctionData('gasPrice'),
    }
  )
  return result && result !== '0x' && BigNumber.from(result)
}
